// Pure helpers for the resume builder.

export type ResumePaper = "letter" | "a4";

/** DOCX page size in twips (1/20 pt). Letter 8.5x11 in, A4 210x297 mm. */
export function docxPageSize(paper: ResumePaper): { width: number; height: number } {
  return paper === "a4" ? { width: 11906, height: 16838 } : { width: 12240, height: 15840 };
}

/** PDF page size in points. */
export function pdfPageSize(paper: ResumePaper): [number, number] {
  return paper === "a4" ? [595.28, 841.89] : [612, 792];
}

/** Download file name: only [a-z0-9-], never raw HTML characters. */
export function resumeFileName(name: string, template: string, ext: "pdf" | "docx"): string {
  const slug = (name || "")
    .normalize("NFKD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60)
    .replace(/-+$/g, "") || "resume";
  const t = (template || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "") || "classic";
  return `${slug}-resume-${t}.${ext}`;
}

const CJK = /[ᄀ-ᇿ぀-ヿ㐀-䶿一-鿿가-힯豈-﫿ｦ-ﾟ]/;
/** True when the text has Chinese, Japanese or Korean characters. */
export function hasCjk(text: string): boolean {
  return CJK.test(text || "");
}
